import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, UserIcon, LockIcon, BellIcon, ShieldIcon, HelpCircleIcon, InfoIcon, LogOutIcon, ChevronRightIcon } from 'lucide-react';
export function Settings() {
  const navigate = useNavigate();
  const sections = [{
    title: 'Account',
    items: [{
      icon: UserIcon,
      label: 'Manage Account',
      onClick: () => navigate('/profile/edit')
    }, {
      icon: LockIcon,
      label: 'Privacy',
      onClick: () => navigate('/settings/privacy')
    }, {
      icon: ShieldIcon,
      label: 'Security',
      onClick: () => navigate('/settings/security')
    }]
  }, {
    title: 'Content & Activity',
    items: [{
      icon: BellIcon,
      label: 'Push Notifications',
      onClick: () => navigate('/settings/notifications')
    }]
  }, {
    title: 'Support',
    items: [{
      icon: HelpCircleIcon,
      label: 'Help Center',
      onClick: () => {}
    }, {
      icon: InfoIcon,
      label: 'About',
      onClick: () => {}
    }]
  }];
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-577">
      <div className="px-4 py-4 flex items-center border-b border-border sticky top-0 bg-black z-10" data-id="element-578">
        <button onClick={() => navigate(-1)} className="text-white mr-4" data-id="element-579">
          <ArrowLeftIcon size={24} data-id="element-580" />
        </button>
        <h1 className="text-white font-poppins font-bold text-lg" data-id="element-581">Settings</h1>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar pb-8" data-id="element-582">
        {sections.map((section, idx) => <div key={idx} className="mt-6" data-id="element-583">
            <h2 className="px-4 text-softGray text-xs font-bold uppercase tracking-wider mb-2" data-id="element-584">
              {section.title}
            </h2>
            <div className="bg-surface border-y border-border" data-id="element-585">
              {section.items.map((item, i) => <button key={i} onClick={item.onClick} className={`w-full flex items-center justify-between px-4 py-4 bg-surface hover:bg-surface2 transition-colors ${i !== section.items.length - 1 ? 'border-b border-border' : ''}`} data-id="element-586">
                  <div className="flex items-center gap-3 text-white" data-id="element-587">
                    <item.icon size={20} className="text-softGray" data-id="element-588" />
                    <span className="text-sm font-medium" data-id="element-589">{item.label}</span>
                  </div>
                  <ChevronRightIcon size={16} className="text-softGray" data-id="element-590" />
                </button>)}
            </div>
          </div>)}

        <div className="mt-8 px-4" data-id="element-591">
          <button onClick={() => navigate('/welcome')} className="w-full flex items-center justify-center gap-2 py-4 bg-surface border border-border rounded-xl text-neonOrange font-bold hover:bg-surface2 transition-colors" data-id="element-592">
            <LogOutIcon size={20} data-id="element-593" />
            Log Out
          </button>
          <p className="text-center text-softGray text-xs mt-4" data-id="element-594">
            Laugh Haus v1.0.0
          </p>
        </div>
      </div>
    </div>;
}